import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { DepositVIPWidgetMainComponent } from './deposit-vip-widget-main.component';



@NgModule({
  declarations: [
    DepositVIPWidgetMainComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ],
  exports:[
    DepositVIPWidgetMainComponent
  ]
})
export class DepositVIPWidgetMainModule {}